module.exports = __webpack_public_path__ + "img/au.e09705d7.svg";